import DashboardDateRange from '../../../components/Backoffice/Dashboard/DashboardDateRange';
import DashboardFilterMultiple from '../../../components/Backoffice/Dashboard/DashboardFilterMultiple';
import DashboardSearch from '../../../components/Backoffice/Dashboard/DashboardSearch';
import { useDashboardContext } from '../../../contexts/DashboardContext';
import { usePropertyContext } from '../../../contexts/PropertyContext';
import { useRoomContext } from '../../../contexts/RoomContext';
import { CONSTANT } from '../../../utils/constants';

function DashboardFilterMultiples() {
  const { dashboardContext, setDashboardFilterMultiple, setDashboardDateRange } =
    useDashboardContext();
  const { roomContext } = useRoomContext();
  const { propertyContext } = usePropertyContext();

  const handleFilter = (key, value) => {
    setDashboardFilterMultiple(key, value);
  };

  const handleDateRange = (dates) => {
    setDashboardDateRange(dates);
  };

  return (
    <div className="flex flex-row gap-x-3">
      <DashboardSearch
        handleSearch={(value) => handleFilter('query', value)}
        value={dashboardContext.filters?.query}
      />
      <DashboardFilterMultiple
        key="type"
        options={CONSTANT.backoffice.residency.typeList}
        value={dashboardContext.filters?.typeList}
        onChange={(value) => handleFilter('typeList', value)}
        emptyLabel="Type"
      />
      <DashboardFilterMultiple
        key="state"
        options={CONSTANT.backoffice.residency.stateList}
        value={dashboardContext.filters?.stateList}
        onChange={(value) => handleFilter('stateList', value)}
        emptyLabel="État"
      />
      <DashboardFilterMultiple
        key="room"
        options={roomContext}
        value={dashboardContext.filters?.roomList}
        onChange={(value) => handleFilter('roomList', value)}
        emptyLabel="Salles"
        showFilter={true}
      />
      <DashboardFilterMultiple
        key="properties"
        options={propertyContext}
        value={dashboardContext.filters?.propertyList}
        onChange={(value) => handleFilter('propertyList', value)}
        emptyLabel="Tags"
        showFilter={true}
      />
      <DashboardDateRange
        key="dates"
        dates={dashboardContext.dateRange}
        onChange={(dates) => handleDateRange(dates)}
        emptyLabel="Période personnalisée"
      />
    </div>
  );
}

export default DashboardFilterMultiples;
